<template>
    <!-- 
        A div is used as the root element so that this component works nicely with transitions.
        If we encounter issues with thatm, we can evaluate to change it.
    -->
    <div>
        <slot />
    </div>
</template>

<script lang="ts">
import { whenever } from '@vueuse/core';
import { Deferred } from '@/helpers/promise';

/**
 * This can be considered a utils component that works together with `<suspense>`.
 *
 * This component returns a promise which will resolve when its props are truthy.
 * The unresolved promise is simulating an async component which results in delayed rendering of the content inside of it.
 *
 * When inside of `<Suspense>`, you can manually increase the suspense period for the wrapped content.
 *
 * Read more about Suspense here: https://vuejs.org/guide/built-ins/suspense.html
 */
export default {
    name: 'SuspenseUntil',
    props: {
        /**
         * suspense the rendering of the content until the value of `true` is `true`.
         */
        true: {
            type: Boolean,
            default: false,
        },
    },
    setup(props) {
        const promise = new Deferred();

        whenever(
            () => props.true as boolean,
            () => promise.resolve({}),
            { immediate: true },
        );

        return promise;
    },
};
</script>

<style lang="scss" scoped></style>
